import { SETTINGS } from '../init';
import Rollbar from './rollbar';
import { LogArgument } from 'rollbar';

const rmnBeacon = (path: string, requestBody: unknown): void => {
  try {
    navigator.sendBeacon(
      `${SETTINGS.API_URL}${path}`,
      JSON.stringify(requestBody),
    );
  } catch (error) {
    Rollbar.error(error as LogArgument);
  }
};

export default rmnBeacon;
